/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-11 17:15:54
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-08-31 16:15:14
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\annual_terminal_performance_report\form\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        actDetailCode: this.paramsProps.actDetailCode,
      },
    };
  },
  components: {},
  methods: {},
  created() {
    this.getConfigList('task-list');
  },
};
